export default __webpack_public_path__ + "static/media/umuahia-terminal.676eb33d.png";